// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD_ch7r8f-jqUq7LS8lYMIqQFpBokCBUEM",
  authDomain: "mindengage-inc.firebaseapp.com",
  projectId: "mindengage-inc",
  storageBucket: "mindengage-inc.firebasestorage.app",
  messagingSenderId: "530234491663",
  appId: "1:530234491663:web:09556d32a5eb52449d347a",
  measurementId: "G-GHNR5JP187"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);